module.exports = __webpack_public_path__ + "resources/img/img_application_service_mesimesb_m.e2665e49517903c18f2027a0da4254e9.png";